import { StyledSpinner, StyledSpinnerImage } from './styledComponents';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import React from 'react';

export default function Loader() {
  return (
    <StyledSpinner>
      <StyledSpinnerImage src={spinner} alt="loading" />
    </StyledSpinner>
  );
}



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/Loader.jsx